import React from 'react';
import Modal from './Modal.jsx';
import LoadingSpinner from './LoadingSpinner.jsx';

/**
 * Modal for displaying AI-generated movie recommendations
 * @param {boolean} show - Whether the modal is visible
 * @param {Function} onClose - Function to close the modal
 * @param {boolean} isGenerating - Whether recommendations are being generated
 * @param {Array} recommendations - List of recommended movies
 * @param {string} error - Error message (if any)
 */
const RecommendationsModal = ({
  show,
  onClose,
  isGenerating,
  recommendations,
  error,
}) => {
  return (
    <Modal show={show} onClose={onClose} title="AI Movie Recommendations">
      {isGenerating ? (
        <div className="flex flex-col items-center justify-center p-8">
          <LoadingSpinner />
          <p className="text-white text-lg">
            Generating personalized recommendations...
          </p>
        </div>
      ) : error ? (
        <p className="text-red-500 text-center text-lg">{error}</p>
      ) : recommendations.length > 0 ? (
        <ul className="space-y-4">
          {recommendations.map((rec, index) => (
            <li key={index} className="bg-gray-800 p-4 rounded-md shadow-md">
              <h3 className="text-xl font-bold text-purple-300 mb-1">
                {rec.title} ({rec.year})
              </h3>
              <p className="text-gray-300">{rec.reason}</p>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-400 text-center">
          No recommendations available at the moment. Add more movies to your
          library!
        </p>
      )}
    </Modal>
  );
};

export default RecommendationsModal;
